import { DynamicFormElement } from '../interfaces/dynamic-form-elements.interface';
import { environment } from '../../../environments/environment';

/**
 * Parses all additionalInfoSerialized properties of widgetOptions to JSON
 * Mutates the original objects!
 * @param inputs
 */
export function parseAdditionalWidgetOptions(inputs: DynamicFormElement[]) {
    if (!inputs) {
        return;
    }

    for (let i = 0; i < inputs.length; i++) {
        const input = inputs[i];

        if (input.widgetOptions && input.widgetOptions.additionalInfoSerialized) {
            try {
                input.widgetOptions.additionalInfoSerialized = JSON.parse(input.widgetOptions.additionalInfoSerialized);
            } catch (e) {
                if (!environment.production) {
                    console.error(`Parsing additionalInfoSerialized failed for widget named '${input.name}'`, e);
                }
            }
        }

        if (input.subInputs) {
            parseAdditionalWidgetOptions(input.subInputs);
        }
    }
}
